<template>
    <div class="addToCart" v-if="type == 'moduleView'">
        <label v-if="fileid == 0 && !locked">Menge</label>
        <input class="form-control" type="number" value="0" v-model="qty" @change="checkQty" @input="checkQty" v-if="fileid == 0 && !locked" />
        <a class="btn btn-primary popup-modal" :href="`#product_`+this.pid"><i class="icon-search"></i></a>
        <a class="btn btn-primary" v-if="locked"><i class="icon-lock"></i></a>
        <a class="btn btn-primary" @click="submit" :disabled="loading" v-if="fileid == 0 && !locked"><i class="icon-cart"></i></a>
        <a :href="`/download/`+fileid+`/`+file" class="btn btn-primary" v-if="fileid != 0 && !locked"><i class="icon-download"></i></a>
    </div>
    <div class="addToCart" v-else-if="type == 'detailView' && fileid == 0">
        <label v-if="!locked">Menge</label>
        <input class="form-control" type="number" value="0" v-model="qty" @change="checkQty" @input="checkQty" v-if="!locked"/>
        <div class="clear"></div>
        <a class="btn btn-primary" @click="submit" :disabled="loading" v-if="!locked">In den Warenkorb</a>
        <div class="text-center" v-if="added">Produkt hinzugefügt</div>
        <br>
        <a href="/cart" class="btn btn-secondary" v-if="!locked">Zum Warenkorb</a>
    </div>
    <div class="addToCart download" v-else-if="type == 'detailView' && fileid != 0">
        <a :href="`/download/`+fileid+`/`+file" class="btn btn-primary" v-if="!locked">Herunterladen</a>
        <div class="text-center" v-if="added">Produkt hinzugefügt</div>
        <br>
        <a href="/cart" class="btn btn-secondary" v-if="!locked">Zum Warenkorb</a>
    </div>
    <div v-else>
        <div class="quantity">
            <input class="form-control" type="number" value="0" v-model="qty" @change="checkQty" @input="checkQty" v-if="fileid == 0 && !locked" />
            <span v-else>&nbsp;</span>
        </div>
        <div class="cart" v-if="locked"><a class="btn btn-primary"><i class="icon-lock"></i></a></div>
        <div class="cart" v-if="fileid == 0 && !locked"><a class="btn btn-primary in-cart-link" @click="submit" :disabled="loading"><i class="icon-cart extra"></i><br /><span class="cart-text">in den <br>Warenkorb</span></a></div>
        <div class="cart" v-if="fileid != 0 && !locked"><a :href="`/download/`+fileid+`/`+file" class="btn btn-primary"><i class="icon-download"></i></a></div>
        <div class="detail"><a class="btn btn-primary popup-modal" :href="`#product_`+this.pid"><i class="icon-search"></i></a></div>
    </div>
</template>
<script>
export default {
  props: {
      type: {
        type: [String],
        default: 'moduleView'
      },
      pid: {
        type: [String],
        default: null
      },
      pstock: {
        type: [Number, String],
        default: 0
      },
      fileid: {
        type: [Number, String],
        default: 0
      },
      file: {
        type: [Number, String],
        default: ""
      },
      locked: {
        type: [Boolean],
        default: false
      }
  },

  data() {
      return {
          qty: 0,
          added: false,
          loading: false
      }
  },

  methods: {
      checkQty() {
          if(this.qty < 0) {
              this.qty = 0;
          } else {
              this.qty = parseInt(this.qty)
          }
      },

      submit() {

        this.loading = true;
        if(this.qty > 0) {
            new Form({
                pid: this.pid,
                qty: this.qty
            })
            .post('/api/cart/add')
            .then((response) => {
                this.loading = false;
                if(response.success) {
                    App.event.fire('cart.updated', response.data);
                    this.added = true;
                    var self = this;
                    swal({
                        title: '',
                        text: 'Produkt wurde zum Warenkorb hinzugefügt',
                        timer: 1000,
                        showConfirmButton: false,
                        type: "success"
                    });
                    setTimeout(function(){ self.added = false; }, 2000);
                } else {
                    swal({ 
                        html:true, 
                        title:'', 
                        text: response.error_text,
                        type: "error"
                    });
                }
                
            }).catch(errors => {
                this.loading = false;
            });
        } else {
            swal({
                title: '',
                text: 'Fügen Sie mindestens 1 Stück zum Warenkorb hinzu.',
                showConfirmButton: true,
                type: "error"
            });
        }
      }
  }
}
</script>
